export default __webpack_public_path__ + "static/media/PaymentBlack.5c363529.svg";